module.exports = __webpack_public_path__ + "img/example13.215126db.jpg";